import { Image } from '../../../api/images/types'
import { Property, PropertyParams } from '../../../api/properties/types'
import { DETAIL_VIEW, MODAL_TYPES } from '../../../common/constants'
import { createActivityDateTime } from '../../../Components/Modals/ActivityModal/utils'
import { generateLocationData } from '../../../utils/general'
import { getAgentPrintData, getFilteredProperty } from '../utils'

export const getModalPayloads = (
    modalType: string,
    property: Property | null | undefined,
    id: string,
    params?: PropertyParams,
    mainPhoto?: Image | null
) => {
    const { DELETE_MODAL, OFFER_BASE_MODAL, TEMPLATES_MODAL, RETURN_TO_OFFER_MODAL, CLONE_MODAL, ACTIVITY_MODAL, AGENT_PRINT_MODAL } = MODAL_TYPES
    const filteredProperty = property ? [getFilteredProperty(property)] : []

    switch (modalType) {
        case DELETE_MODAL:
            return {
                modalType: DELETE_MODAL,
                modalProps: {
                    id: +id,
                    callbackId: 'delete-property',
                    appModule: 'property',
                },
            }
        case OFFER_BASE_MODAL:
            return {
                modalType: OFFER_BASE_MODAL,
                modalProps: {
                    items: filteredProperty,
                    offerType: 'property',
                },
            }
        case TEMPLATES_MODAL:
            return {
                modalType: TEMPLATES_MODAL,
                modalProps: { selectedProperties: filteredProperty },
            }
        case RETURN_TO_OFFER_MODAL:
            return {
                modalType: RETURN_TO_OFFER_MODAL,
                modalProps: { id },
            }
        case CLONE_MODAL:
            return {
                modalType: CLONE_MODAL,
                modalProps: { id, data: ['photos', 'groundPlans', 'video', '3D', 'notes', 'documents'] },
            }
        case ACTIVITY_MODAL:
            return {
                modalType: ACTIVITY_MODAL,
                modalProps: {
                    mode: 'create',
                    event: {
                        ...createActivityDateTime(),
                        property: [{ id: property?.id }],
                        location: generateLocationData(property),
                    },
                    parentId: id,
                    detailView: DETAIL_VIEW.PROPERTY,
                    params,
                },
            }
        case AGENT_PRINT_MODAL:
            return {
                modalType: AGENT_PRINT_MODAL,
                modalProps: {
                    id,
                    agentPrintData: property ? getAgentPrintData(property) : null,
                    mainPhoto: mainPhoto ?? null,
                },
            }
        default:
            return null
    }
}
